import InstallmentsPlaceOrder from './InstallmentsPlaceOrder';

export default InstallmentsPlaceOrder;
